var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyDuotone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.8125 2.1875V9.1875H9.1875V4.8125H4.8125V2.1875H11.8125Z",
    fill: "#667085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8125 1.75H4.8125C4.69647 1.75 4.58519 1.79609 4.50314 1.87814C4.42109 1.96019 4.375 2.07147 4.375 2.1875V4.375H2.1875C2.07147 4.375 1.96019 4.42109 1.87814 4.50314C1.79609 4.58519 1.75 4.69647 1.75 4.8125V11.8125C1.75 11.9285 1.79609 12.0398 1.87814 12.1219C1.96019 12.2039 2.07147 12.25 2.1875 12.25H9.1875C9.30353 12.25 9.41481 12.2039 9.49686 12.1219C9.57891 12.0398 9.625 11.9285 9.625 11.8125V9.625H11.8125C11.9285 9.625 12.0398 9.57891 12.1219 9.49686C12.2039 9.41481 12.25 9.30353 12.25 9.1875V2.1875C12.25 2.07147 12.2039 1.96019 12.1219 1.87814C12.0398 1.79609 11.9285 1.75 11.8125 1.75ZM8.75 11.375H2.625V5.25H8.75V11.375ZM11.375 8.75H9.625V4.8125C9.625 4.69647 9.57891 4.58519 9.49686 4.50314C9.41481 4.42109 9.30353 4.375 9.1875 4.375H5.25V2.625H11.375V8.75Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyDuotone);
export default __webpack_public_path__ + "static/media/copy-duotone.39fe5efaa2c643f7aacb5c9bb6e5e72b.svg";
export { ForwardRef as ReactComponent };